import React from 'react';
import { HeadMetadata } from '../../../../components/HeadMetadata';
import { Header, HeaderWrapper } from '../../../../components/Header';
import { Tiers } from '../../components';

const SEOMetadata = {
  Title: 'Mint Medical Subscription Store | mint REX',
  Description:
    'mint REX - Elevate your oncology clinical trial evaluations with response criteria assessment in an easy-to-use Microsoft Excel add-in.'
};

export function LandingPage() {
  return (
    <>
      <HeadMetadata
        title={SEOMetadata.Title}
        description={SEOMetadata.Description}></HeadMetadata>

      <HeaderWrapper>
        <Header>Choose Your mint REX Plan</Header>
      </HeaderWrapper>

      <Tiers></Tiers>
    </>
  );
}
